class ProductStickyBar extends HTMLElement {
  connectedCallback() {
    this.addToCartButton = document.getElementById("sticky-bar-add-to-cart");
    this.backInStockButton = document.getElementById(
      "sticky-bar-back-in-stock"
    );
    this.currentSize = document.getElementById("sticky-bar-current-size");
    this.sizeButtons = Array.from(
      document.querySelectorAll(".product-sticky-bar__size-dropdown-button")
    );
    this.sizeOption = document.getElementById("sticky-bar-size-option");

    this.loadEventListeners();
  }

  disconnectedCallback() {
    this.removeEventListeners();
  }

  addToCartHandler(event) {
    event.preventDefault();
    event.stopPropagation();

    const buttonWrapper = document.getElementById("sticky-bar-button-wrapper");
    const productFormButton = document.getElementById(
      "product-add-to-cart-button"
    );

    if (buttonWrapper && productFormButton) {
      buttonWrapper.setAttribute("data-loading", "true");
      productFormButton.click();

      setTimeout(() => {
        buttonWrapper.setAttribute("data-loading", "false");
      }, 500);
    }
  }

  backInStockHandler(event) {
    event.preventDefault();
    event.stopPropagation();

    const notifyMeTrigger = document.getElementById("product-notify-me-trigger");

    if (notifyMeTrigger) {
      notifyMeTrigger.click();
    }
  }

  loadEventListeners() {
    if (this.addToCartButton) {
      this.addToCartButton.addEventListener("click", (event) =>
        this.addToCartHandler(event)
      );
    }

    if (this.backInStockButton) {
      this.backInStockButton.addEventListener("click", (event) =>
        this.backInStockHandler(event)
      );
    }

    if (this.sizeOption) {
      this.sizeOption.addEventListener("click", (event) =>
        this.sizeOptionToggleHandler(event)
      );
    }

    window.addEventListener("DOMContentLoaded", () =>
      this.sizeSelectionHandler()
    );
    //window.addEventListener("scroll", () => this.visibilityHandler());

    this.visibilityHandlerSetUp();
  }

  removeEventListeners() {
    if (this.addToCartButton) {
      this.addToCartButton.removeEventListener("click", (event) =>
        this.addToCartHandler(event)
      );
    }

    if (this.backInStockButton) {
      this.backInStockButton.removeEventListener("click", (event) =>
        this.backInStockHandler(event)
      );
    }

    if (this.sizeOption) {
      this.sizeOption.removeEventListener("click", (event) =>
        this.sizeOptionToggleHandler(event)
      );
    }

    window.removeEventListener("DOMContentLoaded", () =>
      this.sizeSelectionHandler()
    );

    //window.removeEventListener("scroll", () => this.visibilityHandler());

    this.visibilityHandlerTearDown();
  }

  sizeOptionToggleHandler(event) {
    const parent = event.target.closest("#sticky-bar-size-wrapper");
    const isOpen = parent.getAttribute("data-open");

    if (isOpen === "false") {
      parent.setAttribute("data-open", "true");
    } else {
      parent.setAttribute("data-open", "false");
    }
  }

  sizeSelectionHandler() {
    if (this.sizeButtons.length) {
      this.sizeButtons.forEach((button) => {
        button.addEventListener("click", (event) => {
          const { inStock, variantId, variantTitle } = button.dataset;

          if (inStock === "false") {
            return;
          }

          const parent = event.target.closest("#sticky-bar-size-wrapper");
          parent.setAttribute("data-open", "false");

          const matchingVariantButton = document.querySelector(
            `variant-button[data-variant-button="${variantId}"]`
          );
          matchingVariantButton.click();

          this.currentSize.textContent = variantTitle;
        });
      });
    }
  }

  visibilityHandlerSetUp(){
    this.intersectionObserver = new IntersectionObserver(this.intersectObserver__itemVisibilityChanged.bind(this), { root: null, threshold: 0.01 });
    this.intersectionObserver.observe(document.querySelector('[data-visibility-trigger]'));
  }

  visibilityHandlerTearDown(){
    this.intersectionObserver.disconnect();
  }

  intersectObserver__itemVisibilityChanged(entries, observer) {
    entries.forEach( entry => this.setAttribute("data-visible", !entry.isIntersecting));
  }

  visibilityHandler() {
    const main = document.getElementById("MainContent");
    const { top } = main.getBoundingClientRect();

    if (main && top >= -275) {
      this.setAttribute("data-visible", "false");
    } else {
      this.setAttribute("data-visible", "true");
    }
  }
}

customElements.define("product-sticky-bar", ProductStickyBar);
